import * as React from 'react';

export interface ICarViewSuggestionTextProps {
  onClick: () => void;
  suggestedValue: string | null | undefined;
  currentValue: string | null | undefined;
}

export const CarViewSuggestionText: React.FunctionComponent<
  ICarViewSuggestionTextProps
> = props => {
  if (!props.suggestedValue || props.suggestedValue === props.currentValue) {
    return null;
  }
  return (
    <span
      className='cursor-default text-blue-500 hover:underline'
      onClick={() => {
        props.onClick();
      }}
    >
      Did you mean <span className='italic'>{props.suggestedValue}</span>?
    </span>
  );
};
